<template>
	<div id="app" class="min-h-screen bg-gray-50 flex flex-col">
		<AppHeader v-if="!route.meta.isAuthCallback" />
		<RouterView class="flex-1" />
		<AppFooter v-if="!route.meta.isAuthCallback" />
	</div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';

const route = useRoute();
</script>
